import xtend from 'xtend';
import _ from 'underscore';
import S from 'pull-stream';
import many from 'pull-many';
import DeferPkg from 'pull-defer';
const Defer = DeferPkg.source;
import pathOr from 'ramda/src/pathOr';
import path from 'ramda/src/path';
import dissocPath from 'ramda/src/dissocPath';
import assocPath from 'ramda/src/assocPath';
import findIndex from 'ramda/src/findIndex';
import propEq from 'ramda/src/propEq';
import VastModel from './vast';
import EventsModel from './events';
import EventsQuery from './events-query';
import CategoriesModel from './categories';
import AssetsModel from './assets';
import VastListModel from './vast-list';
import actionFromId from '../util';
import { toShortID } from '../../../utils/parse-event-id';


function createVastEditModel (api) {
    var vastModel = VastModel(api);
    var eventsModel = EventsModel(api);
    var categoriesModel = CategoriesModel(api);
    var assetsModel = AssetsModel(api);
    var vastListModel = VastListModel(api);

    function VastEditModel () {
        return {
            activeTab: 0,
            pendingEdits: {},
            vast: vastModel(),
            events: eventsModel(),
            eventsQuery: EventsQuery(),
            categories: categoriesModel(),
            assets: assetsModel(),
            vastList: vastListModel(),
            messages: [],
            adsAreValid: false
        };
    }

    VastEditModel.effects = {
        submitQuery: function (state, msg, ev) {
            var q = xtend(state.eventsQuery);
            delete q.searchBy;
            return eventsModel.effects.get(state.events, msg.events, q);
        },

        saveCampaign: function (state, msg, ev) {
            var req = xtend({
                campaignID: state.vast.data.campaignID,
                assets: state.pendingEdits.campaignAssets,
                events: state.pendingEdits.campaignEvents,
                categories: state.pendingEdits.campaignCategoryIDs
            }, state.vast.data, state.pendingEdits);

            delete req.campaignEvents;
            delete req.campaignAssets;
            delete req.campaignCategoryIDs;

            // @FIXME
            // need to encapsulate the stream stuff
            // should use a flatMap type thing
            // @TODO
            // better way to parse the events
            if (!req.campaignID) {
                var reset = Defer();
                var req = S(
                    vastModel.effects.add(state.vast, msg.vast, req),
                    S.through(function (ev) {
                        if (ev[1][0] === 'add') {
                            // success
                            reset.resolve(S.once(msg.reset()));
                        }
                        if (ev[1][0] === 'pushError') {
                            // error
                            reset.resolve(S.empty());
                        }
                    })
                );

                console.log('req', req, reset);

                return many([req, reset]);
            }

            // @FIXME
            var reset = Defer();
            var req = S(
                vastModel.effects.edit(state.vast, msg.vast, req),

                S.through(function (ev) {
                    if (ev[1][0] === 'edit') {
                        // success
                        reset.resolve(S.once(msg.reset()));
                    }
                    if (ev[1][0] === 'pushError') {
                        // error
                        reset.resolve(S.empty());
                    }
                })
            );

            return many([req, reset]);
        },

        vast: vastModel.effects,
        events: eventsModel.effects,
        categories: categoriesModel.effects,
        assets: assetsModel.effects,
        vastList: vastListModel.effects
    };

    // @TODO
    // it would be good to map the state here into something easier for
    // the view. The [vast|events|assets|categories].errors props could
    // go into a single top level queue.
    // But then how do we keep it testable?
    VastEditModel.update = {
        changeTab: function (state, ev) {
            return xtend(state, { activeTab: ev });
        },

        changeScope: function (state, ev) {
            return xtend(state, {
                pendingEdits: xtend(state.pendingEdits, {
                    typeID: ev
                })
            });
        },

        editTitle: function (state, ev) {
            var edits = xtend(state.pendingEdits, {
                name: ev
            });

            if (!edits.name) delete edits.name;

            return xtend(state, {
                pendingEdits: edits
            });
        },

        reset: function (state, ev) {
            return xtend(state, {
                pendingEdits: {}
            });
        },

        cancelTitleEdit: function (state, ev) {
            var newEdits = xtend(state.pendingEdits);
            delete newEdits.name;
            return xtend(state, {
                pendingEdits: newEdits
            });
        },

        assignCategory: assign(
            ['pendingEdits', 'campaignCategoryIDs'],
            ['vast', 'data', 'campaignCategoryIDs']
        ),

        unassignCategory: remove(
            ['pendingEdits', 'campaignCategoryIDs'],
            ['vast', 'data', 'campaignCategoryIDs']
        ),

        assignCampaignEvent: function (state, ev) {
            var getEventID = _.compose(toShortID, path(['eventID']));
            var list = (
                state.pendingEdits.campaignEvents ||
                (state.vast.data.campaignEvents || []).map(getEventID)
            );
            return assocPath(
                ['pendingEdits', 'campaignEvents'],
                [ev].concat(list),
                state
            );
        },

        unassignCampaignEvent: function (state, ev) {
            var existing = (state.vast.data.campaignEvents || [])
                .map(_.compose(toShortID, path(['eventID'])));

            var list = _(state.pendingEdits.campaignEvents || existing)
                .without(ev);

            if (!list.length &&
                !(state.vast.data.campaignEvents || []).length) {
                return dissocPath(
                    ['pendingEdits', 'campaignEvents'],
                    state
                );
            }
            return assocPath(['pendingEdits', 'campaignEvents'], list, state);
        },

        assignAsset: function (state, ev) {
            var list = state.pendingEdits.campaignAssets ||
                (state.vast.data.campaignAssets || []).map(
                    _.partial(_.pick, _, ['weight', 'assetID', 'clickURL'])
                )
            ;

            return assocPath(
                ['pendingEdits', 'campaignAssets'],
                [CampaignAsset(ev)].concat(list),
                state
            );
        },

        editAsset: function (state, ev) {
            var list = state.pendingEdits.campaignAssets ||
                (state.vast.data.campaignAssets || []).map(
                    _.partial(_.pick, _, ['weight', 'assetID', 'clickURL'])
                )
            ;

            var i = findIndex(propEq('assetID', ev.assetID), list);

            return assocPath(
                ['pendingEdits', 'campaignAssets'],
                assocPath([i], xtend(list[i], ev), list),
                state
            );
        },

        removeAsset: function (state, ev) {
            var list = _(state.pendingEdits.campaignAssets ||
                (state.vast.data.campaignAssets || []).map(
                    _.partial(_.pick, _, ['weight', 'assetID', 'clickURL'])
                )
            ).reject(function (asset) {
                return asset.assetID === ev;
            });

            if (!list.length &&
                !(state.vast.data.campaignAssets || []).length) {
                return dissocPath(
                    ['pendingEdits', 'campaignAssets'],
                    state
                );
            }

            return assocPath(
                ['pendingEdits', 'campaignAssets'],
                list,
                state
            );
        },

        changeStartDate: function (state, ev) {
            return xtend(state, {
                pendingEdits: xtend(state.pendingEdits, {
                    startDate: ev
                })
            });
        },

        changeEndDate: function (state, ev) {
            return xtend(state, {
                pendingEdits: xtend(state.pendingEdits, {
                    endDate: ev
                })
            });
        },

        // pre/mid/post roll ad position
        // ev is like: { pre: true }
        changeAction: function (state, ev) {
            var actions = actionFromId[(
                state.pendingEdits.actionID === undefined ?
                    state.vast.data.actionID :
                    state.pendingEdits.actionID
            )];

            var newActions = ['pre', 'mid', 'post'].map(function (name, i) {
                return ev[name] === undefined ?
                    actions[i] :
                    ev[name]
                ;
            });

            return xtend(state, {
                pendingEdits: xtend(state.pendingEdits, {
                    actionID: _(actionFromId).findIndex(function (elmt) {
                        return _.isEqual(newActions, elmt);
                    })
                })
            });
        },

        vast: vastModel.update,
        events: eventsModel.update,
        eventsQuery: EventsQuery.update,
        categories: categoriesModel.update,
        assets: assetsModel.update,
        vastList: vastListModel.update
    };

    return VastEditModel;
}

function CampaignAsset (id) {
    return {
        assetID: id,
        weight: 5,
        clickURL: ''
    };
}

function assign (pendingPath, existingPath) {
    return function (state, ev) {
        var pending = pathOr([], pendingPath, state);
        var existing = pathOr([], existingPath, state);
        var hasEdited = !!pending.length;

        var newList = [ev].concat(hasEdited ? pending : existing);
        return assocPath(pendingPath, newList, state);
    };
}

function remove (pendingPath, existingPath, state, ev) {
    return function (state, ev) {
        var pending = pathOr([], pendingPath, state);
        var existing = pathOr([], existingPath, state);

        var newList = _(path(pendingPath, state) ?
            pending :
            _.uniq(pending.concat(existing))
        ).without(ev);

        if (!newList.length && !existing.length) {
            return dissocPath(pendingPath, state);
        }
        return assocPath(pendingPath, newList, state);
    };
}

createVastEditModel.DEFAULT_QUERY = EventsQuery.DEFAULT_QUERY;

export default createVastEditModel;
